import { Row, Col, Spin, message, Skeleton } from "../ui/ot";
import { useState, useEffect } from 'react';
import { lazy } from 'react';
import { Suspense } from 'react';
import { usePermission } from './controller/PermissionController'
import { useFrontendColumnFrontendComponent } from './controller/frontend_column_frontend_component_controllerr'
import { useBackground } from '../component_layout/BackgroundContext'

const MainPage = (
    {
        prefixTitle = '',
        title = '首頁',
        permissionId = 0
    }
) => {
    const [blogTypeData, setBlogTypeData] = useState([])
    const [add_modal, set_add_modal] = useState(false)
    const [component_number, set_component_number] = useState(1)
    const [restart, setRestart] = useState('false')
    const [loading, setLoading] = useState(false)
    // const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const { setBackgroundImage } = useBackground();
    const [pageContainerData, setPageContainerData] = useState([]);
    const [permissionData, setPermissionData] = useState({});
    useEffect(() => {
    }, [permissionId])

    const {
        getPermissionMainPageData
    } = usePermission(
        {
            onBefore: () => { },
            onFinish: () => { },
        }
    );
    useEffect(() => {
        getPermissionMainPageData({
            permission_id: permissionId,
            classify_structure_id: 5,
            classify_structure_type_id: 0,
        })
            .then((response) => {
                let firstData = response.find(_ => true)
                let permission_page_data = firstData?.permission_page_data || []
                let permission_page_data_first = permission_page_data.find(_ => true)
                let frontend_component_blog_type_data = permission_page_data_first?.frontend_component_blog_type_data || []
                setBackgroundImage(permission_page_data_first?.property_json?.backgroundImage || '');

                setPermissionData(firstData)
                setPageContainerData(() => {
                    return frontend_component_blog_type_data || [];
                });
            })
    }, [permissionId])
    useEffect(() => {
        document.title = `${prefixTitle} | ${title}`
        setPageContainerData([])

    }, [title])

    return (
        <>
            {loading ?
                <>
                    <Spin />
                </>
                :
                <>
                    {/* MainPage */}
                    {/* <EMILayout> */}
                    <Row justify={'center'} gutter={[8, 16]}>
                        {permissionData?.show === 1 && <>
                            <Col span={24}>
                                <Row
                                    justify={'center'}
                                    align="middle"
                                    style={{
                                        backgroundImage: `linear-gradient(to right, ${permissionData?.property_json?.background_color1}, #ffffff,${permissionData?.property_json?.background_color2})`, padding: '10px',
                                        position: 'relative',
                                    }}>
                                    <Col style={{ textAlign: 'center' }}>
                                        <span style={{
                                            fontSize: permissionData?.property_json?.size ? permissionData.property_json.size : "3vmin",
                                            fontWeight: permissionData?.property_json?.blod ? 900 : "normal",
                                            fontStyle: permissionData?.property_json?.italic ? "italic" : "normal",
                                            textDecoration: permissionData?.property_json?.textDecoration ? "underline" : "none"
                                        }}>
                                            {permissionData.name}
                                        </span>
                                    </Col>
                                    {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                                                                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                                                                        </Col> */}
                                </Row>
                            </Col>
                            {/* 副標題 */}
                            {/* <Col span={24}>
                                <Row gutter={[40, 16]} justify="center" align="middle" style={{ margin: '10px' }}>
                                    <Col md={{ span: 6 }} sm={{ span: 24 }}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                        </Row>
                                    </Col>
                                    <Col md={{ span: 8 }} sm={{ span: 24 }} >
                                        <Row justify={'center'}>
                                            <Col >
                                                <span dangerouslySetInnerHTML={{ __html: permissionData.subheading }}></span>
                                            </Col>
                                        </Row>

                                    </Col>
                                    <Col md={{ span: 6 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col> */}
                        </>}

                        {/* <Col span={24}>
                            {marquee_color && <>
                                <Marquee style={{ height: '2em', backgroundColor: `rgba(${marquee_color.r}, ${marquee_color.g}, ${marquee_color.b}, ${marquee_color.a})`, fontSize: '2vh' }} speed={marquee_speed}>
                                    <NotificationFilled />{marquee_text}
                                </Marquee>
                            </>}
                            <Carousel_news_ticker
                                height={'20vh'}
                            />
                        </Col> */}
                        {/* {console.log(pageContainerData)} */}
                        {
                            (pageContainerData || [])?.map((rowData, rowIndex) => {
                                if (!Boolean(rowData.frontend_row_hidden)) {
                                    return (
                                        rowData?.page_frontend_row_data
                                            ?.map((columnData, columnIndex) => {

                                                return (
                                                    columnData?.frontend_row_frontend_column_data?.map((componentData, componentIndex) => {
                                                        return (
                                                            <Col span={24}>
                                                                <Row>
                                                                    <Col span={24}>
                                                                        {/* <Row gutter={[10, 20]} justify="space-around"> */}
                                                                        {/* {componentRender(componentData.frontend_component_name, componentData.frontend_column_frontend_component_blog_type_data)} */}
                                                                        <ComponentRender
                                                                            frontend_column_frontend_component_id={componentData.frontend_column_frontend_component_id}
                                                                            component_name={componentData.frontend_component_name}
                                                                            blogTypeData={componentData.frontend_column_frontend_component_blog_type_data}
                                                                        />
                                                                        {/* </Row> */}
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                        )
                                                    })
                                                )

                                            })
                                    )
                                }



                            })
                        }
                    </Row>
                    {/* </EMILayout> */}
                </>
            }
        </>
    )
}
export default MainPage;
const ComponentRender = ({
    frontend_column_frontend_component_id = 0,
    component_name = "",
    blogTypeData = []
}) => {
    const [loading, setLoading] = useState(false)
    const {
        FrontendColumnFrontendComponentData,
        getFrontendColumnFrontendComponentData
    } = useFrontendColumnFrontendComponent({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: () => {
            setLoading(false)
        }
    })
    useEffect(() => {
        getFrontendColumnFrontendComponentData({
            frontend_column_frontend_component_id
        })
    }, [])

    const Component = lazy(() => import(`./components/${component_name}`))
    if (FrontendColumnFrontendComponentData.length !== 0) {
        return (
            <Suspense fallback={<></>}>
                <Component
                    blogTypeData={FrontendColumnFrontendComponentData?.find(_ => true)?.frontend_column_frontend_component_blog_type_data}
                />
            </Suspense>
        )
    }
    else {
        return (<>
            {loading && <Skeleton />}
            {!loading && <Suspense fallback={<></>}>
                <Component
                // blogTypeData={blogTypeData}
                />
            </Suspense>}
        </>)
    }
}